import React, { useState, useEffect } from 'react';
import useStyles from './styles';

import Header from '../../components/Header';
import ScrumRow from '../../components/ScrumRow';

function Board({data, onDataChange, onCardAdd}) {
  const c = useStyles();
  

  const boardChangeHandler = (e) => {
  }

  const onColsChange = (newData, index) => {
    var tempData = JSON.parse(JSON.stringify(data));
    tempData[index].cols = newData;
    onDataChange(tempData);
  }

  return (
    <>
      {data.map((row, index) => {
        return <ScrumRow onCardAdd={onCardAdd} onColsChange={e => onColsChange(e, index)} key={index} id={index} cols={row?.cols || []} showTags={index === 0}></ScrumRow>

      })}
    </>
  );
}




export default Board;